import { render, staticRenderFns } from "./ModalRequestOTP.vue?vue&type=template&id=cb5a8152&scoped=true&"
import script from "./ModalRequestOTP.vue?vue&type=script&lang=js&"
export * from "./ModalRequestOTP.vue?vue&type=script&lang=js&"
import style0 from "./ModalRequestOTP.vue?vue&type=style&index=0&id=cb5a8152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5a8152",
  null
  
)

export default component.exports